import {
  DisplayOn,
  ESegmentationBehavior,
  FilterCondition,
  RecurringType,
  ShowDuring,
  TimingType,
} from "./enums";
import moment from "moment";

export class AutopilotRule {
  constructor(
    public id: string,
    public name: string,
    public color: number,
    public isActive: boolean,

    public recurringType: RecurringType = null,
    public timeBasedIntervalMins: number = 30,
    public timeBasedTimeStartMs: number = 0,
    public timeBasedTimeEndMs: number = 0,
    public timeBasedGraphicDurationMs: number = 1800000,
    public videoBasedDisplayOn: DisplayOn = null,
    public videoBasedFilterTags: string[] = [],
    public videoBasedTiming: TimingType = TimingType.BeforeVideoStarts,
    public videoBasedTimingVideoDurationMs: number = null,
    public videoBasedFilterCondition: FilterCondition = FilterCondition.Or,
    public videoBasedTimingInterval = 1,
    public alwaysBasedDuring: ShowDuring = null,
    public limitRule: boolean = null,
    public limitRuleStartDate: moment.Moment = null,
    public limitRuleEndDate: moment.Moment = null,
    public limitRuleStartTime: moment.Moment = null,
    public limitRuleEndTime: moment.Moment = null,
    public graphicId: number = null,
    public floatingMediaId: number = null,
    public videoBasedTimingMinSec: number = 1,
    public videoBasedFitToWholeVideo: boolean = false,
    public segmentationBehaviour: ESegmentationBehavior = ESegmentationBehavior.ApplyOnEverySegment,
  ) {}
}
